export interface ItemWithLabel<T> {
  label: string;
  value: T;
  disabled?: boolean;
  labelClassList?: string;
}
